import axios from "axios";
import axiosInstance from "../../translator";
import { tenantManagementAPI as tenant } from "../../constants/apis/apiEndpoints";
import { dynamicListMapper, userListMapper } from "../../utils/genericUtils";
import { localStorageHelper } from "../../utils/storageHelper";
import { translator } from "../../constants/actionTypes";

export const fetchTenantListData = async (urlParams) => {
  return axiosInstance
    .get(`${tenant?.tenantEndpoint}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createTenantApi = async (urlParams) => {
  return axiosInstance
    .post(tenant?.tenantEndpoint, urlParams)
    .then((response) => {
      return { data: response?.data, status: response?.status };
    })
    .catch((error) => {
      return error;
    });
};

export const editTenantApi = async (urlParams) => {
  return axiosInstance
    .put(`${tenant?.tenantEndpoint}/${urlParams.id}`, urlParams.payload)
    .then((response) => {
      return { data: response?.data, status: response?.status };
    })
    .catch((error) => {
      return error;
    });
};

export const deleteTenantApi = async (urlParams) => {
  return axiosInstance
    .delete(`${tenant?.tenantEndpoint}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const playPauseTenantApi = async (payload) => {
  return axiosInstance
    .patch(`${tenant?.tenantEndpoint}/${tenant?.subscriptionstatus}/${payload?.id}`, payload?.data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const viewTenantApi = async (id) => {
  return axiosInstance
    .get(`${tenant?.tenantEndpoint}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getTenantUserList = async (data) => {
  return axiosInstance
    .get(`${tenant?.usersByRoleEndpoint}?role=${data}`)
    .then((response) => {
      const list = userListMapper(response?.data[0]);
      return {
        data: list,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const getMachineCatalogs = async () => {
  return axiosInstance
    .get(`${tenant?.machineCatalogEndpoint}`)
    .then((response) => {
      const list = dynamicListMapper(response?.data[0], "display_name", "id", "id");
      return {
        data: list,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const getTenantDetailsByID = async (data) => {
  return axiosInstance
    .get(`${tenant?.tenantEndpoint}/${data}`)
    .then((response) => {
      return {
        data: response?.data,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const pricingSummeryApi = async (payload) => {
  return axiosInstance
    .get(`${tenant?.tenantEndpoint}${tenant?.pricingProfile}/${payload?.id}?profile_type=${payload?.profileType}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const setQuotaFormApi = async (payload) => {
  return axiosInstance
    .post(`${tenant.setQuota}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createPricingProfileApi = async (data) => {
  return axiosInstance
    .post(`${tenant?.tenantEndpoint}${tenant?.pricingProfile}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const setQuotaFormGetApi = async (id) => {
  return axiosInstance
    .get(`${tenant.setQuota}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editPricingProfileApi = async (payload) => {
  return axiosInstance
    .put(`${tenant?.tenantEndpoint}${tenant?.pricingProfile}/${payload?.id}`, payload?.data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const setQuotaFormUpdateApi = async (id, payload) => {
  return axiosInstance
    .put(`${tenant.setQuota}/${id}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notificationSettingFormApi = async (payload) => {
  return axiosInstance
    .post(`${tenant.notificationSetting}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notificationSettingGetApi = async (id) => {
  return axiosInstance
    .get(`${tenant.notificationSetting}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notificationSettingUpdateApi = async ({ payload }) => {
  return axiosInstance
    .put(`${tenant.notificationSetting}/${payload?.id}`, payload?.data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchTenantSummary = async (id) => {
  return axiosInstance
    .get(`${tenant?.allTenantSummary}${id}`)
    .then((response) => {
      return {
        data: response?.data,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const getExtAndExpData = async (id) => {
  return axiosInstance
    .get(`${tenant?.extAndExp}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createExtAndExpApi = async (payload) => {
  return axiosInstance
    .post(`${tenant.extAndExp}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateExtAndExpApi = async ({ data, id }) => {
  return axiosInstance
    .put(`${tenant.extAndExp}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const uploadHtmlTemplate = async (data) => {
  return axios
    .post(`${translator.baseURL}${tenant?.htmlTemplate}`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        tenant: localStorageHelper.get("tenantId"),
        accessToken: `Bearer ${localStorageHelper.get("accessToken")}`,
        Authorization: `${localStorageHelper.get("authToken")}`,
        role: localStorageHelper.get("role"),
        authtype: localStorageHelper.get("auth_type"),
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const fetchHtmlTemplateList = async () => {
  return axiosInstance
    .get(`${tenant?.htmlTemplate}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchTenantSettings = async (id) => {
  const tenantSettings = axiosInstance
    .get(`${tenant?.tenantEndpoint}${tenant?.settingsList}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return tenantSettings;
};
